import styles from "./index.module.css";
const Cast = ({ data,movieName }) => {
  return (
    <div className={styles.ctn}>
      <h1>{movieName}</h1>
      <div className={styles.list}>
        {data.map(({ post, name }) => {
          return (
            <div className={styles.item}>
              <h6>{post}</h6>
              <h5>{name}</h5>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Cast;
